import { Descriptions, Form, Input, Button, Space } from 'antd'
import { useEffect } from 'react'
import { ReloadOutlined, SearchOutlined } from '@ant-design/icons'
import useGetCheckDetailProductList from '../hooks/useGetCheckDetailProductList'
import useGetCheckBillAmountText from '../hooks/useGetCheckBillAmountText'
import CheckProductList from './CheckProductList'
import moment from 'moment'
const desMap = [
  { name: '盘点单据', key: 'checkNo' },
  { name: '盘点名称', key: 'sheetName' },
  { name: '单据状态', key: 'checkStatusName' },
  { name: '经手人', key: 'checkUserName' },
  {
    name: '盘点时间',
    key: 'finishTime',
    formate: val => moment(val).format('YYYY-MM-DD HH:mm')
  },
  { name: '备注', key: 'note' }
]
export default function CheckDetail({ detail = {} }) {
  const { getList, loading, pageData } = useGetCheckDetailProductList()
  const { amountInfoText } = useGetCheckBillAmountText(detail)
  const [form] = Form.useForm()
  const freshList = (res = {}) => {
    return getList({
      formDate: { ...res, checkNo: detail.checkNo },
      pageIndex: 1,
      pageSize: pageData.pageSize
    })
  }
  useEffect(() => {
    detail.checkNo && freshList()
    return () => {}
  }, [detail.checkNo])
  return (
    <>
      <Descriptions>
        {desMap.map((item, index) => (
          <Descriptions.Item key={index} label={item.name}>
            {item.formate ? item.formate(detail[item.key]) : detail[item.key]}
          </Descriptions.Item>
        ))}
      </Descriptions>
      <Form form={form} layout='inline' onFinish={freshList}>
        <Form.Item name='queryKey' label='商品信息'>
          <Input placeholder='商品名称/条码/商品编码' />
        </Form.Item>
        <Form.Item>
          <Space>
            <Button
              type='primary'
              ghost
              onClick={() => form.submit()}
              icon={<SearchOutlined />}>
              查询
            </Button>
            <Button
              type='primary'
              ghost
              icon={<ReloadOutlined />}
              onClick={() => form.resetFields()}>
              重置
            </Button>
          </Space>
        </Form.Item>
      </Form>
      <div style={{ marginTop: '20px' }}></div>
      <CheckProductList
        pageData={pageData}
        loading={loading}
        getList={getList}
        page
      />
      {amountInfoText}
    </>
  )
}
